import { useEffect, useState } from 'react';

export default function useMobileLayout() {
  const [mobile, setMobile] = useState(() => window.matchMedia?.('(max-width: 760px)').matches ?? false);
  useEffect(() => {
    const query = window.matchMedia?.('(max-width: 760px)');
    if (!query) return undefined;
    const update = () => setMobile(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return mobile;
}
